<template>
  <div style="border: 0px solid black; width:100%;">
    <div class="welcome" style="border: 0px solid red;">
      <row
        style="border:0px solid green;position: inherit;display:contents;width:100%;"
      >
        <div class="box box-success">
          <div class="box-header with-border">
            <h3 class="box-title">{{ $t("search.title") }}</h3>
          </div>

          <div class="box-body">
            <div class="row" style="margin-bottom: 10px;">
              <div class="col-sm-3 col-md-3 col-lg-3">
                <input
                  type="text"
                  v-on:keyup.enter="onSearchApartment"
                  class="form-control"
                  :placeholder="$t('apartment.owner_resident')"
                  v-model="search.owner_resident"
                />
              </div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <input
                  v-on:keyup.enter="onSearchApartment"
                  type="text"
                  class="form-control"
                  :placeholder="$t('apartment.apartment_code')"
                  v-model="search.apartment_code"
                />
              </div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <input
                  v-on:keyup.enter="onSearchApartment"
                  type="number"
                  class="form-control"
                  :placeholder="$t('apartment.fromsize')"
                  v-model="search.fromsize"
                />
              </div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <input
                  v-on:keyup.enter="onSearchApartment"
                  type="number"
                  class="form-control"
                  :placeholder="$t('apartment.tosize')"
                  v-model="search.tosize"
                />
              </div>
            </div>
            <!-- <div class="row">
              <div class="col-sm-3 col-md-3 col-lg-3">
                <lte-section-select2
                  @selectData="onSelectApartmentStatus"
                  @unselectData="onUnselectApartmentStatus"
                  :data="columnApartmentStatus.data_list"
                  :placeHolder="$t('common.status')"
                ></lte-section-select2>
              </div>
            </div> -->
            <div class="row">
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <button
                  type="button"
                  class="btn btn-labeled btn-success pull-right"
                  @click="onSearchApartment"
                >
                  <span class="btn-label">
                    <i class="glyphicon glyphicon-search"></i>
                  </span>
                  {{ $t("search.search_button") }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="box box-primary" style="width:100%">
          <div class="box-header with-border">
            <div
              style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
            >
              <b>{{ $t("apartment.title_lease_back") }}</b>
            </div>
            <div class="col-md-12 col-ld-12 col-sd-12">
              <!-- <div class="col-sm-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar">
                        <label>
                          <span
                            style="margin-left:5px;display:inline-block;"
                          >{{$t('service_history.date_from')}}:</span>
                        </label>
                      </i>
                    </div>
                    <date-picker
                      :value="bookingDate.checkin_datetime"
                      v-model="bookingDate.checkin_datetime"
                    ></date-picker>
                  </div>
                </div>
              </div>-->

              <!-- <div class="col-sm-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar">
                        <label>
                          <span
                            style="margin-left:5px;display:inline-block;"
                          >{{$t('service_history.date_to')}}:</span>
                        </label>
                      </i>
                    </div>
                    <date-picker
                      :value="bookingDate.checkout_datetime"
                      v-model="bookingDate.checkout_datetime"
                    ></date-picker>
                  </div>
                </div>
              </div>-->
              <div class="col-md-4 col-lg-4 col-sm-4" style="float:right;">
                <div class="form-group">
                  <lte-button
                    v-show="false"
                    style="float:right;background-color:white !important;"
                    type="btn btn-default"
                    right_icon="fa fa-retweet"
                    @click="onMoveToServiceApartment($event)"
                    >{{
                      $t("apartment.move_to_resident_apartment")
                    }}</lte-button
                  >
                  <lte-button
                    v-show="false"
                    v-if="
                      has_perm('import_apartment') || GET_ACCOUNT_DATA.id == 1
                    "
                    style="float:right;background-color:white !important;"
                    type="btn btn-default"
                    right_icon="fa fa-plus"
                    @click="importExcel($event)"
                    >{{ $t("apartment.importExcel") }}</lte-button
                  >
                  <select-option-check
                    v-show="false"
                    style="float:right;width:34px;height:32px;margin-top:4px;"
                    :item="columnsApartment"
                    class="dropdown-trigger"
                    data-icon="eye"
                    @callbackData="onColumnSelect"
                  ></select-option-check>
                </div>
              </div>

              <!-- <div class="col-sm-2 col-md-2 col-lg-2">
                <button
                  :disabled="isDisable"
                  type="button"
                  class="btn btn-labeled btn-warning pull-left"
                  @click="onSearchAvailableApartment"
                >
                  <span class="btn-label">
                    <i class="glyphicon glyphicon-search"></i>
                  </span>
                  {{$t('search.check_availability_button')}}
                </button>
              </div>-->
            </div>
          </div>

          <div class="box-body">
            <lte-table
              v-if="has_perm('view_lease_back') || GET_ACCOUNT_DATA.id == 1"
              ref="lte_table"
              :hdBackground="hdBackground"
              :data="gridApartmentDataList"
              :columns="gridColumns"
              :actions="has_perm('update_lease_back') ? actions : []"
              search_filter="left-search"
              @actions="crudActions"
              :useFilter="useFilter"
              :row_mouse_pointer="false"
              :boxStyle="boxStyle"
              :useCheckBox="useCheckBox"
              @selectedItems="selectedItems"
            ></lte-table>
          </div>
        </div>
        <div
          class="box-footer clearfix"
          style="display:contents;"
          v-if="has_perm('view_apartment') || GET_ACCOUNT_DATA.id == 1"
        >
          <paginator :item="paginatorItem" @onpaginate="onPagination" />
        </div>
        <lte-modal
          v-show="isModalVisible"
          @onConfirm="onConfirm"
          @close="closeModal"
          v-for="obj in objModal"
          :key="obj.id"
          :item="obj"
        ></lte-modal>
        <lte-modal
          v-show="isModalMoveToServiceApartment"
          @onConfirm="onConfirmMoveToResidentApartment"
          @close="closeModalMoveTo"
          v-for="obj in objModalMoveToResidentApartment"
          :key="obj.id"
          :item="obj"
        ></lte-modal>
        <lte-modal-confirm-moving
          ref="modalConfirmMoving"
          @movingconfirmation="onConfirmMoveToResidentApartment"
        ></lte-modal-confirm-moving>
        <lte-core-alert
          v-for="snackbar in GET_SNACK_BAR"
          :key="snackbar.id"
          :item="snackbar"
        ></lte-core-alert>
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          color="#1E90FF"
        ></loading>
      </row>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { LTEActionTypeEnum } from '@/components/LTEEnum'
import LTEButton from "@/components/LTEButton.vue";
import LTETable from "@/components/LTETable.vue";
import LTEModal from "@/components/LTEModal.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Paginator from "@/components/Paginator.vue";
import Loading from "vue-loading-overlay";
import utils from "@/lib/utils";
import SelectOptionCheck from "@/components/SelectOptionCheck.vue";
// import sectionselect2 from "@/components/LTESelect2Section";
import LTEModalConfirmMovingApartment from "@/components/LTEModalConfirmMovingApartment";
// import datePicker from "vue-bootstrap-datetimepicker";
import constants from "@/lib/constantsData";

export default {
  name: "LeaseBackApartmentList",
  data() {
    return {
      buttonName: "danger",
      labelName: "Name",
      gridApartmentDataList: [],
      useFilter: false,
      boxStyle: false,
      useCheckBox: true,
      list_apartment_id: [],
      bookingDate: {
        checkin_datetime: null,
        checkout_datetime: null
      },
      gridColumns: [
        { text: "common.nonumber", isHidden: true },
        { text: "common.code", isHidden: true },
        { text: "apartment.apartment_code", isHidden: true },
        { text: "apartment.size", isHidden: true },
        //{ text: "apartment.status", isHidden: true },
        { text: "apartment.owner_resident", isHidden: true }
      ],
      actions: ["common.modify"],
      columnsApartment: {
        data_list: [],
        itemType: 1,
        showLabel: false,
        modifyFromPosition: "margin-top:-300px",
        cssClassSm1: "col-md-1",
        cssClassSm2: "col-sm-1",
        showAddNew: false
      },
      columnApartmentStatus: {
        data_list: constants.apartmentStatusText,
        itemType: 1,
        showLabel: false,
        modifyFromPosition: "margin-top:-300px",
        cssClassSm1: "col-md-1",
        cssClassSm2: "col-sm-1",
        showAddNew: false,
        apartment: true
      },
      statusSelected: [],
      //actions: ["common.booking"],
      //hdBackground         : "background-color: #4b646f;color:white;border-bottom:2px solid #f4f4f4;", //00a65a
      hdBackground:
        "background-color: #4b646f;color:white;border:1px solid white;", //00a65a
      tblBorder: "border: 1px solid orange",
      originalRecordData: [],
      isModalVisible: false,
      isModalMoveToServiceApartment: false,
      objModal: [
        {
          title    : "common.delete_modal.title",
          body     : "common.delete_modal.content",
          buttonNo : "common.delete_modal.btnNo",
          buttonYes: "common.delete_modal.btnYes",
          styleType: "default"
        }
      ],
      objModalMoveToResidentApartment: [
        {
          title: "Chuyển Đổi Căn Hộ Tới Căn Hộ Để Ở",
          body:
            "Bạn có chắc chắn muốn chuyển đổi căn hộ dịch vụ sang căn hộ để ở không?",
          buttonNo: "Hủy",
          buttonYes: "Đồng Ý",
          styleType: "default"
        }
      ],
      paginatorItem: {
        commit_function: "GET_APARTMENT_LIST"
      },
      search: {
        code: "",
        apartment_code: "",
        fromsize: "",
        tosize: "",
        status: "",
        owner_resident: ""
      },
      isLoading: false,
      module_id: 4,
      permissions: [],
      dataMovingList: {},
      options: {
        format: "DD/MM/YYYY",
        useCurrent: false
      }
    };
  },
  watch: {
    GET_LANG: function() {
      const data = {
        params: {
          page: 1,
          apt_type: 2
        }
      };
      this.GET_APARTMENT_LIST(data);
    },
    GET_APARTMENT_LIST_DATA: function() {
      this.gridApartmentDataList = [];
      this.GET_APARTMENT_LIST_DATA.forEach((apartment, i) => {
        let nonumber =
          i + 1 + (this.PAGINATION.page - 1) * this.PAGINATION.size;
        let code = apartment.code;
        let id = apartment.id;
        let apartment_code = apartment.apartment_code;
        let size = apartment.size;
        let status =
          apartment.status === 1
            ? this.$t("apartment_status.not_handover")
            : apartment.status === 2
            ? this.$t("apartment_status.handover")
            : apartment.status === 3
            ? this.$t("apartment_status.occupied")
            : apartment.status === 4
            ? this.$t("apartment_status.not_rented")
            : this.$t("apartment_status.rented");
        let full_name_owner = "";

        if (apartment.status != 1) {
          let object_resident = apartment.resident.filter(
            item => item.isOwner === true
          );
          if (object_resident.length > 0) {
            full_name_owner =
              object_resident[0].resident.last_name +
              " " +
              object_resident[0].resident.first_name;
          }
        }

        let data = {
          id: id,
          "common.nonumber": nonumber,
          "common.code": code,
          "apartment.apartment_code": apartment_code,
          "apartment.size": size,
          "apartment.status": status,
          "apartment.owner_resident": utils.capitalizeFirstInString(
            full_name_owner
          )
        };
        this.gridApartmentDataList.push(data);
      });
    },
    GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA: function() {
      if (!utils.isNull(this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data)) {
        let newGridColumns = [];
        const viewedColumnsKey = Object.keys(
          this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data.viewed_columns
        );
        const viewedColumns = this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data
          .viewed_columns;
        for (
          let j = 0, sizeOrigin = this.gridColumns.length;
          j < sizeOrigin;
          j++
        ) {
          for (let i = 0, size = viewedColumnsKey.length; i < size; i++) {
            if (this.gridColumns[j].text == viewedColumnsKey[i]) {
              let viewdColumnObject = {};
              viewdColumnObject.text = viewedColumnsKey[i];
              viewdColumnObject.isHidden = viewedColumns[viewedColumnsKey[i]];
              newGridColumns.push(viewdColumnObject);
              break;
            }
          }
        }
        this.gridColumns = newGridColumns;
        this.columnsApartment.data_list = this.gridColumns;
      }
    },
    GET_CURRENT_ROLE: function() {},
    GET_BOOKINGS_BY_APARTMENT_BEFORE_MOVING_DATA: function() {
      if (!utils.isNull(this.GET_BOOKINGS_BY_APARTMENT_BEFORE_MOVING_DATA)) {
        let dataNotMove = [];
        this.GET_BOOKINGS_BY_APARTMENT_BEFORE_MOVING_DATA.apartments_not_move.forEach(
          item => {
            let checkin_datetime = utils.formatSqlDate(item.checkin_datetime, null, this.options.format);
            let checkout_datetime = utils.formatSqlDate(item.checkout_datetime, null, this.options.format);
            let arrived_start_date = utils.formatSqlDate(item.arrived_start_date, null, this.options.format);
            let data = {
              apartment_code: item.apartment_code,
              arrived_start_date: arrived_start_date,
              booking_code: item.booking_code,
              checkin_datetime: checkin_datetime,
              checkout_datetime: checkout_datetime
            };
            dataNotMove.push(data);
          }
        );
        this.dataMovingList["apartments_not_move"] = dataNotMove;
        this.dataMovingList[
          "apartments_move"
        ] = this.GET_BOOKINGS_BY_APARTMENT_BEFORE_MOVING_DATA.apartments_move;
      }
    }
  },
  computed: {
    isDisable() {
      if (
        this.bookingDate.checkin_datetime != null &&
        this.bookingDate.checkout_datetime != null
      ) {
        return false;
      }
      this.resetApartmentDataList();
      return true;
    },
    ...mapGetters([
      "PAGINATION",
      "GET_SNACK_BAR",
      "GET_APARTMENT_LIST_DATA",
      "GET_ACCOUNT_DATA",
      "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA",
      "GET_LANG",
      "GET_APARTMENTPERMISSIONS_DATA",
      "GET_BOOKINGS_BY_APARTMENT_BEFORE_MOVING_DATA"
    ])
  },
  methods: {
    resetApartmentDataList: function() {
      this.gridApartmentDataList = [];
    },
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    updateSelectedApartmentStatus: function() {
      if (!utils.isNull(this.statusSelected)) {
        for (let j = 0, sizeApartmentStatus = this.columnApartmentStatus.data_list.length; j < sizeApartmentStatus; j++) {
          for (let k = 0, sizeStatusSelected = this.statusSelected.length; k < sizeStatusSelected; k++) {
            if (this.statusSelected[k] == this.columnApartmentStatus.data_list[j].id) {
              this.columnApartmentStatus.data_list[j]["selected"] = "selected";
            }
          }
        }
      }
    },
    onSelectApartmentStatus: function(data) {
      if (this.statusSelected.indexOf(parseInt(data.id)) == -1) {
        this.statusSelected.push(parseInt(data.id));
      }
    },
    onUnselectApartmentStatus: function(data) {
      if (this.statusSelected.indexOf(parseInt(data.id)) != -1) {
        this.statusSelected.splice(
          this.statusSelected.indexOf(parseInt(data.id)),
          1
        );
      }
    },
    onColumnSelect: function(tables) {
      let tableDataObj = {};
      let tableDataObjChild = {};
      tableDataObjChild["tablename"] = "apartmentlist";
      tables.data_list.forEach(element => {
        tableDataObj[element.text] = element.isHidden;
      });
      tableDataObjChild["tablerow"] = tableDataObj;
      this.SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG(tableDataObjChild)
        .then(function() {}.bind(this))
        .catch(function() {}.bind(this));
    },
    onSearchApartment: function() {
      this.$store.state.leaseBackApartmentSearchListStorage[
        "apartmentCode"
      ] = this.search.apartment_code;
      this.$store.state.leaseBackApartmentSearchListStorage[
        "fromSize"
      ] = this.search.fromsize;
      this.$store.state.leaseBackApartmentSearchListStorage[
        "toSize"
      ] = this.search.tosize;
      this.$store.state.leaseBackApartmentSearchListStorage[
        "ownerResident"
      ] = this.search.owner_resident;
      this.$store.state.leaseBackApartmentSearchListStorage[
        "statusSelected"
      ] = this.statusSelected;
      const data = {
        params: {
          page: 1,
          apt_type: 2,
          apartment_code: this.search.apartment_code,
          from_size: this.search.fromsize,
          to_size: this.search.tosize,
          status: this.statusSelected,
          owner_resident: this.search.owner_resident
        }
      };
      this.isLoading = true;
      this.GET_APARTMENT_LIST(data).then(
        function() {
          this.isLoading = false;
        }.bind(this)
      );
    },
    addNew: function() {
      this.$router.push({
        name: "ApartmentAdd",
        params: {
          id: 0
        }
      });
    },
    importExcel: function() {
      this.$router.push({
        name: "ApartmentImportExcel",
        params: {
          id: 0
        }
      });
    },
    crudActions: function(recordData, actionsType, isModalVisible) {
      if (actionsType == LTEActionTypeEnum.MODIFY) {
        this.$router.push({
          name: "LeaseBackApartmentDetail",
          params: {
            id: recordData.id
          }
        });
      } else if (actionsType == LTEActionTypeEnum.BOOKING) {
        this.$router.push({
          name: "LeaseBackApartmentBooking",
          params: {
            id: recordData.id,
            checkin_datetime: this.bookingDate.checkin_datetime,
            checkout_datetime: this.bookingDate.checkout_datetime
          }
        });
      } else {
        if (this.has_perm("delete_apartment") || GET_ACCOUNT_DATA.id == 1) {
          this.originalRecordData = recordData;
          this.isModalVisible = isModalVisible;
        } else {
          alert("Bạn Không Có Quyền Để Xóa");
        }
      }
    },
    onConfirm: function() {
      this.isModalVisible = false;
      this.search.apartment_code = this.$store.state.leaseBackApartmentSearchListStorage.apartmentCode;
      this.search.fromsize = this.$store.state.leaseBackApartmentSearchListStorage.fromSize;
      this.search.tosize = this.$store.state.leaseBackApartmentSearchListStorage.toSize;
      this.search.owner_resident = this.$store.state.leaseBackApartmentSearchListStorage.ownerResident;
      this.statusSelected = this.$store.state.leaseBackApartmentSearchListStorage.statusSelected;
      this.DELETE_PROPERTY(this.originalRecordData) .then(
        function() {
          let currentPage = this.PAGINATION.page;
          let totalPage = this.PAGINATOR.length;
          let page =
            currentPage >= totalPage && this.gridCustomerDataList.length == 1
              ? totalPage - 1
              : currentPage;
          const data = {
            params: {
              page: page,
              apt_type: 2,
              apartment_code: this.search.apartment_code,
              from_size: this.search.fromsize,
              to_size: this.search.tosize,
              owner_resident: this.search.owner_resident,
              status: this.statusSelected
            }
          };
          this.GET_APARTMENT_LIST(data);
          this.SUCCESS_TOAST();
        }.bind(this)
      )
      .catch(
        function() {
          this.ERROR_TOAST();
        }.bind(this)
      );
    },
    onPagination: function(data) {
      const filter = {
        params: {
          page: data.params.page,
          apt_type: 2,
          apartment_code: this.search.apartment_code,
          from_size: this.search.fromsize,
          to_size: this.search.tosize,
          owner_resident: this.search.owner_resident,
          status: this.statusSelected
        }
      };
      this.GET_APARTMENT_LIST(filter);
    },
    closeModal() {
      this.isModalVisible = false;
    },
    closeModalMoveTo() {
      this.isModalMoveToServiceApartment = false;
    },
    selectedItems: function(list_apartment_id) {
      this.list_apartment_id = list_apartment_id;
    },
    onMoveToServiceApartment: function() {
      if (this.list_apartment_id.length <= 0) {
        this.ON_SHOW_TOAST({
          message: "Xin Vui Lòng Chọn 1 Căn Hộ",
          styleType: "danger"
        });
        return;
      }
      this.isLoading = true;
      let payload = {
        data: this.list_apartment_id
      };
      this.GET_BOOKINGS_BY_APARTMENT_BEFORE_MOVING(payload)
        .then(
          function() {
            this.isLoading = false;
            this.$refs.modalConfirmMoving.submit(this.dataMovingList);
          }.bind(this)
        )
        .catch(
          function(error) {
            this.ON_SHOW_TOAST({
              message: this.messages[error.response.data.message],
              styleType: "danger"
            });
            this.isLoading = false;
          }.bind(this)
        );

      //this.isModalMoveToServiceApartment = true;
    },
    onConfirmMoveToResidentApartment: function(idsList) {
      this.isLoading = true;
      this.list_apartment_id = idsList;
      let payload = {
        data: this.list_apartment_id,
        apartment_type: "resident_apt"
      };
      this.CHANGE_RESIDENT_TO_SERVICE_APARTMENT(payload)
        .then(
          function() {
            this.SUCCESS_TOAST();
            this.isLoading = false;
            //this.isModalMoveToServiceApartment = false;
            const filter = {
              params: {
                page: 1,
                apt_type: 2,
                apartment_code: this.search.apartment_code,
                from_size: this.search.fromsize,
                to_size: this.search.tosize,
                owner_resident: this.search.owner_resident,
                status: this.statusSelected
              }
            };
            this.GET_APARTMENT_LIST(filter);
          }.bind(this)
        )
        .catch(
          function(error) {
            this.ON_SHOW_TOAST({
              message: this.messages[error.response.data.message],
              styleType: "danger"
            });
            this.isLoading = false;
          }.bind(this)
        );
    },
    onSearchAvailableApartment: function() {
      this.isLoading = true;
      const filter = {
        params: {
          page: 1,
          apt_type: 2,
          apartment_code: this.search.apartment_code,
          from_size: this.search.fromsize,
          to_size: this.search.tosize,
          owner_resident: this.search.owner_resident,
          status: this.statusSelected,
          checkin_datetime: utils.formatSqlDate(this.bookingDate.checkin_datetime, null, "DD/MM/YYYY", ""),
          checkout_datetime: utils.formatSqlDate(this.bookingDate.checkout_datetime, null, "DD/MM/YYYY", "")
        }
      };
      this.GET_APARTMENT_LIST(filter)
        .then(
          function() {
            this.isLoading = false;
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
            this.gridApartmentDataList = [];
            this.ON_SHOW_TOAST({
              message: error.response.data.message,
              styleType: "danger"
            });
          }.bind(this)
        );
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "GET_APARTMENT_LIST",
      "SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG",
      "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG",
      "GET_PERMISSIONS_BYMODULE",
      "ON_SHOW_TOAST",
      "CHANGE_RESIDENT_TO_SERVICE_APARTMENT",
      "GET_BOOKINGS_BY_APARTMENT_BEFORE_MOVING",
      "DELETE_PROPERTY"
    ])
  },
  components: {
    "lte-button": LTEButton,
    "lte-table": LTETable,
    "lte-modal": LTEModal,
    "lte-core-alert": LTECoreAlert,
    paginator: Paginator,
    loading: Loading,
    "select-option-check": SelectOptionCheck,
    // "lte-section-select2": sectionselect2,
    "lte-modal-confirm-moving": LTEModalConfirmMovingApartment
    // "date-picker": datePicker
  },
  mounted() {
    this.search.apartment_code = this.$store.state.leaseBackApartmentSearchListStorage.apartmentCode;
    this.search.fromsize = this.$store.state.leaseBackApartmentSearchListStorage.fromSize;
    this.search.tosize = this.$store.state.leaseBackApartmentSearchListStorage.toSize;
    this.search.owner_resident = this.$store.state.leaseBackApartmentSearchListStorage.ownerResident;
    this.statusSelected = !utils.isNull(
      this.$store.state.leaseBackApartmentSearchListStorage.statusSelected
    )
      ? this.$store.state.leaseBackApartmentSearchListStorage.statusSelected
      : [];

    const data = {
      params: {
        page: 1,
        apt_type: 2,
        apartment_code: this.search.apartment_code,
        from_size: this.search.fromsize,
        to_size: this.search.tosize,
        owner_resident: this.search.owner_resident,
        status: this.statusSelected,
        checkin_datetime: this.bookingDate.checkin_datetime,
        checkout_datetime: this.bookingDate.checkout_datetime
      }
    };
    this.GET_APARTMENT_LIST(data);
    this.columnsApartment.data_list = this.gridColumns;
    const filter = {
      params: {
        tablename: "apartmentlist"
      }
    };

    this.GET_PERMISSIONS_BYMODULE({
      params: {
        module_id: 4
      }
    });

    this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG(filter);
    this.updateSelectedApartmentStatus()
  }
};
</script>

<style scoped>
.search {
  box-shadow: none;
  border-color: #d2d6de;
  z-index: 2;
  float: left;
  margin-bottom: 8px;
  margin-right: 5px;
  height: 30px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 3px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.size-180 {
  width: 180px;
}

.search-tools {
  padding-right: 0px;
  padding-left: 0px;
  width: auto;
}
.select-option-status {
  margin-top: -12px;
  display: inline-block;
}

@media only screen and (max-width: 1000px) {
  .select-option-status {
    float: none;
    margin-top: 4px;
  }
}
@media only screen and (max-width: 768px) {
  .select-option-status {
    float: none;
    margin-top: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Apartment/LeaseBackApartmentList.vue